export const floatOrDefault = (stringValue, defaultValue) => {
  const floatValue = parseFloat(stringValue)
  if (isNaN(floatValue)) return defaultValue
  return floatValue
}
